import { C_ACTION } from '../constans';

export const user = (state = {}, action) => {
  switch (action.type) {
    case C_ACTION.ADD_USER: {
      return { ...action.user, auth: true };
    }
    case C_ACTION.REMOVE_USER: {
      return { auth: false };
    }
    case C_ACTION.CHANGE_USER: {
      return { ...state, ...action.user };
    }
    default:
      return state;
  }
};
